const companiesLocalize = {
  "CNPJ Invalid": 'CNPJ Invalido',
  "Not Found store": "Loja não encontrada",
  "Fail Delete users": 'Não foi possível deletar'
};

export default companiesLocalize;
